import { useDispatch, useSelector } from "react-redux";
import { GeometryType } from "@evergis/api";
import {
  GeometryEditorMode,
  Positions,
  resetGeometryEditor,
  setGeometryEditor,
} from "../../../ducks/geometryEditor/geometryEditor";
import { useUpdate } from "../../../hooks/useUpdate";
import { getGeometryEditorMode } from "../../../ducks/geometryEditor/selectors";
import { EditGeometryType } from "../../../evergis/core/attributes/geometryTypes";

type EditorPayload = {
  layerName: string;
  geometry: Positions;
  geometryType?: GeometryType | EditGeometryType;
};

export const useEditUpdateEffect = (isEdit: boolean, { geometryType, layerName, geometry }: EditorPayload) => {
  const dispatch = useDispatch();
  const editorMode = useSelector(getGeometryEditorMode);

  useUpdate(() => {
    if (isEdit) {
      const mode = editorMode === void 0 ? GeometryEditorMode.Edit : editorMode;

      dispatch(setGeometryEditor({ geometryType, layerName, geometry, mode }));
    } else {
      dispatch(resetGeometryEditor());
    }
  }, [isEdit, editorMode]);
};
